import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListCardSkeleton } from '../Common/PageSkeleton';
import userAPI from '../../services/userAPI';
import logo from '../../assets/waseeny-logo.png';
import { formatMoney } from '../../utils/formatMoney';
import NotificationBell from '../Common/NotificationBell';
import './Profile.css';

const Refunds = () => {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRefunds();
  }, []);

  const fetchRefunds = async () => {
    try {
      setLoading(true);
      const data = await userAPI.getRefunds();
      setRefunds(data?.refunds || []);
    } catch (err) {
      console.error('Failed to fetch refunds:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'processed':
      case 'approved': return '#48c479';
      case 'pending': return '#f39c12';
      case 'rejected': return '#e74c3c';
      default: return '#7f8c8d';
    }
  };

  return (
    <div className="profile-container">
      <header className="profile-header" style={{display: 'flex', alignItems: 'center', padding: '10px 20px', gap: '15px', borderBottom: '1px solid #eee'}}>
        <button onClick={() => navigate(-1)} style={{background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M14 5l-6 6 6 6" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <img src={logo} alt="Logo" className="profile-logo" onClick={() => navigate('/home')} style={{height: '35px', cursor: 'pointer'}} />
        <h1 className="profile-title" style={{fontSize: '18px', margin: 0, flex: 1}}>My Refunds</h1>
        <NotificationBell />
      </header>

      <div className="profile-content">
        <div className="profile-card">
          {loading ? (
            <ListCardSkeleton count={2} />
          ) : refunds.length === 0 ? (

            <div className="empty-state">
              <p>No refund requests found.</p>
            </div>
          ) : (
            <div className="refund-list">
              {refunds.map((refund) => (
                <div key={refund._id} className="refund-item" style={{
                  padding: '20px',
                  border: '1px solid #eee',
                  borderRadius: '12px',
                  marginBottom: '16px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <span style={{ fontWeight: '700' }}>Order #{refund.order?._id?.slice(-6) || 'N/A'}</span>
                    <span style={{ 
                      color: getStatusColor(refund.status),
                      fontWeight: '600',
                      fontSize: '14px',
                      textTransform: 'uppercase'
                    }}>
                      {refund.status}
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#666' }}>{new Date(refund.createdAt).toLocaleDateString()}</span>
                    <span style={{ fontWeight: '700', fontSize: '18px' }}>{formatMoney(refund.amount, { symbol: refund.currencySymbol || '' })}</span>
                  </div>
                  <div style={{ marginTop: '10px', fontSize: '13px', color: '#888' }}>
                    Method: {refund.method === 'wallet' ? 'Wallet Credit' : 'Payment Gateway'}
                  </div>
                  {refund.note && (
                    <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: '#888', fontStyle: 'italic' }}>
                      Note: {refund.note}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Refunds;
